import { combineReducers } from 'redux-immutable'

import tabReducer from './components/TabBar/reducer'
import groupReducer from './components/StackContent/components/GroupsContent/reducer'
import historyReducer from './components/StackContent/components/HistoryContent/reducer'
import favouriteReducer from './components/StackContent/components/FavouritesContent/reducer'
import searchReducer from './components/StackContent/components/SearchContent/reducer'
import exportsReducer from './components/StackContent/components/ExportsContent/reducer'

const entityStackReducer = combineReducers({
    tabs: tabReducer,
    search: searchReducer,
    groups: groupReducer,
    history: historyReducer,
    favourites: favouriteReducer,
    exports: exportsReducer,
})

export default entityStackReducer
